function makeList(rowsArr) {
    return {
        total: rowsArr.length,
        items: rowsArr,
    };
}
export default makeList;
//# sourceMappingURL=makeList.js.map